export const ProcedureType = {
  IMAGING: "imaging",
  LABORATORY: "laboratory",
};

export const OrderType = {
  ...ProcedureType,
  MANUAL: "manual",
  /**
   * UI-only tab that unifies imaging + laboratory search.
   * Never sent to the backend — each card resolves to its real ProcedureType.
   */
  PRACTICES: "practices",
};

export const ItemType = {
  NOMENCLATURE: "nomenclature",
  TEMPLATE: "template",
};

export const DEFAULT_SEARCH_OPTIONS = {
  searchNomenclature: true,
  searchTemplates: true,
};

export const resultsMapper = (item, itemType, procedureType = null) => ({
  ...item,
  name: item.name,
  itemType,
  procedureType,
  metadata: itemType === ItemType.TEMPLATE ? { template: item } : {},
});
